import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DefaultIconSelect, DefaultIconsPoiMapping, DefaultSpeciesIcons, GameRecord, HuntingDistrict, NetworkConstants, PointOfInterest } from 'diwimamodelweb/lib';
import * as turf from '@turf/turf'
import * as mapboxgl from 'mapbox-gl';
import {createIconImage} from 'diwimamodelweb/lib/utils/map.utils'
import {LaboratorySampleStatusIcons} from 'diwimamodelweb/lib'
import { SettingsService } from '../settings.service';
import { HuntingDistrictService } from '../hunting-district.service';
import { environment } from 'src/environments/environment';
import { PointOfInterestForm } from '../model/form';
import * as geojson from 'geojson';

@Component({
  selector: 'app-map-info-display',
  templateUrl: './map-info-display.component.html',
  styleUrls: ['./map-info-display.component.css']
})
export class MapInfoDisplayComponent implements OnInit {

  @Input() object: GameRecord|PointOfInterest|PointOfInterestForm|HuntingDistrict|any
  @Input() geoObjectTypes: any
  @Output() onMapClick: EventEmitter<void> = new EventEmitter()
  mapStyleOutdors = environment.mapBoxStyleStreets
  mapStyleSatellite = environment.mapBoxStyleOutdoors
  zoomHeight = 13.5

  map: mapboxgl.Map
  _browserLanguage = navigator.language
  dropdownSettingGeoObjectType: any[]

  constructor(
    private settingsService: SettingsService,
    private huntingDesitrictService: HuntingDistrictService
  ) { }

  async ngOnInit() {
    switch(this.object.className) {
      case(GameRecord.name): {
        // diplay point
        const location = (this.object as GameRecord).placeOfKilling?.location
        let center: mapboxgl.LngLat|undefined = undefined
        if (location) {
          center = new mapboxgl.LngLat(location.longitude, location.latitude);
        }
        this.createMap(center)
        break
      }
      case(PointOfInterest.className): {
        // display point 
        // diplay point
        const location = (this.object as PointOfInterest).locationCoordinates
        let center: mapboxgl.LngLat|undefined = undefined
        if (location) {
          center = new mapboxgl.LngLat(location.longitude, location.latitude);
        }
        this.createMap(center)
        break
      }

      case(PointOfInterestForm.className): {
        switch(this.object.data.contentType?.toLowerCase()){
          case 'point':{
            this.dropdownSettingGeoObjectType = this.object.constextSettings.get(NetworkConstants.SETTING_GEO_TYPE).values
            break;
          }
    
          case 'line':{
            this.dropdownSettingGeoObjectType = this.object.constextSettings.get(NetworkConstants.SETTING_GEO_LINE_TYPES).values
            break;
          }
    
          case 'polygon': {
            this.dropdownSettingGeoObjectType = this.object.constextSettings.get(NetworkConstants.SETTING_GEO_POLYGON_TYPES).values
            break;
          }
    
          default:{
            this.dropdownSettingGeoObjectType = this.object.constextSettings.get(NetworkConstants.SETTING_GEO_TYPE).values
            break;
          }
        }

        const location = (this.object.data as PointOfInterest).locationCoordinates
        let center: mapboxgl.LngLat|undefined = undefined
        if (location) {
          center = new mapboxgl.LngLat(location.longitude, location.latitude);
        }
        this.createMap(center)
        break
      }
      case(HuntingDistrict.className): {
        // display bounds ... 
        try {
          await this.huntingDesitrictService.getOutlinesOfDistrict(this.object)
          this.createMap()
        } catch (error) {
          console.error(error)
        }
        break
      }
      default: {
        this.createMap()
        break
      }
    }
    
    // recieve all pois selected from home.component
    this.map.on('load', () => {
      this._onMapLoad()
    })
    this.map.on('click', () => {
      this.onMapClick.emit()
    })
  }

  private createMap(center?: mapboxgl.LngLat) {
    this.map = new mapboxgl.Map(
      {
        container: 'map',
        style: `${this.mapStyleOutdors}`,
        zoom: this.zoomHeight, 
        center: center ? center : [10.369743, 51.081317],
        interactive: true
      }
    )
  }

  private flyToBounds(district: HuntingDistrict) {
    let features: any[] = [...district.getOutlinesAsFeatureList()]
    if (features.length > 0) {
      const featureCollection = turf.featureCollection(features)
      const boundingBox = turf.bbox(featureCollection)
      const mapbbox = new mapboxgl.LngLatBounds([boundingBox[0], boundingBox[1]], [boundingBox[2], boundingBox[3]])
      // mapbbox.extend() maybe for fitting multiple bboxes... 
      this.map.fitBounds(mapbbox, {padding: 15})     
    }
  }

  get defaultSpeciesIcons() {
    return DefaultSpeciesIcons
  }

  get defaultPoiIcons() {
    return [...DefaultIconsPoiMapping.values()]
  }

  onMapStyleSelectChange(event) {
    // this.subPOI.unsubscribe()
    // this.subDistricts.unsubscribe()
    let layerId = event.value
    this.map.setStyle(
      `${layerId}`
    )
    this.map.on('style.load', () => {
      this._onMapLoad()
    })
  }

  private _onMapLoad() {

    this.map.resize()
    //console.log('className: ', this.object.className)

    switch(this.object.className) {
      case(GameRecord.className): {
        this.addMapSource('gr-source', this.object.getFeature(""))
        break
      }
      case(PointOfInterest.className): {
        this.addMapSource('gr-source', this.object.getFeature(""))
        break
      }

      case(PointOfInterestForm.className): {
        const icon = this.dropdownSettingGeoObjectType?.find( type => type.identifier?.toLowerCase() == this.object.data.type?.toLowerCase())?.iconName
        if(this.object.data.encodedContent){
          let features = this.object.data.getFeatures()
          this.flyToBoundsGeoObject(this.object.data,  features)

          if(this.object.data.contentType)
          this.createGeoObjectPolygonLine(this.object.data, features)
        } else{
        let feature = this.object.data.getFeature("",icon)  
        this.addMapSource('gr-source', feature)
        }
        break
      }
      case(HuntingDistrict.className): {
        this.flyToBounds(this.object)
        // display polygon
        this.createDistPolygon(this.object)
        break
      }
      default:{
        // ?? nothing
        break
      }
    }

    DefaultSpeciesIcons.forEach(async (iconName: string) =>{
      var canvas = document.getElementById(iconName) as HTMLCanvasElement
      if (canvas) {
        const imageData = await createIconImage(canvas, iconName)
        if (imageData) {
          this.map.addImage(iconName, imageData) 
        }
      }
    })

    DefaultIconSelect.forEach(async (value, key) => {
      var canvas = document.getElementById(value) as HTMLCanvasElement
      if (canvas) {
        const imageData = await createIconImage(canvas, value)
        if (imageData) {
          this.map.addImage(value, imageData)  
        }
      }
    })
  }

  private async addMapSource(sourceId: string, features: any) {
    const source = this.map.getSource(sourceId) as mapboxgl.GeoJSONSource
    if (source == null) {
      this.map.addSource(sourceId, {
        type: 'geojson', data: features, cluster: false})
      // this.addClusterLayer(sourceId)
    } else {
      source.setData(features)
    }
    //console.log(sourceId)
    this.map.addLayer(
      {
        id: `unclustered-points-${sourceId}`,
        type: 'symbol',
        // type: 'circle',
        source: `${sourceId}`,
        filter: ['!', ['has', 'point_count']],
        // paint: {
        //   'circle-color': '#FFB300',
        //   'circle-radius': 8,
        //   'circle-stroke-width': 1,
        //   'circle-stroke-color': '#fff'
        // },
        layout: {
          'icon-image': ['get', 'icon'],
          'icon-size': 0.75,
          // 'icon-offset': [0, -30],
          // 'icon-anchor':'center'
        }
      }
    )
  }

  private createDistPolygon(dist: HuntingDistrict) {
    var layers = this.map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    var firstSymbolId;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].type === 'line') {
        firstSymbolId = layers[i].id;
        break;
      }
    }
    const source = this.map.getSource(dist.identifier) as mapboxgl.GeoJSONSource
    if (source == null) {
      // this._internalCurrentlyVisiblePolygons.push(dist.identifier)
      const geoJson = dist.getOutlineGeoJson()
      if (geoJson) {
        this.map.addSource(dist.identifier, geoJson)
        this.map.addLayer({
          'id': dist.identifier,
          'type': 'fill',
          'source': dist.identifier,
          'layout': {},
          'paint': {
            'fill-color': '#FFB300',
            'fill-opacity': 0.6
          }
        }, firstSymbolId)
        this.map.moveLayer(dist.identifier);
      }
    }
  }

  private createGeoObjectPolygonLine(poi: PointOfInterest, features) {
    var layers = this.map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    var firstSymbolId;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].type === 'line') {
        firstSymbolId = layers[i].id;
        break;
      }
    }
    const source = this.map.getSource(poi.identifier) as mapboxgl.GeoJSONSource
    if (source == null) {
      const geojson = this.object.data.getGeoJsonFromFeatures(features)
      this.map.addSource(poi.identifier, geojson)

      if(this.object.data?.contentType?.toLowerCase()== 'polygon'){
        this.map.addLayer({
          'id': poi.identifier,
          'type': 'fill',
          'source': poi.identifier,
          'layout': {},
          'paint': {
            'fill-color': '#FFB300',
            'fill-opacity': 0.6
          }
        }, firstSymbolId)
        this.map.moveLayer(poi.identifier);
      }

      if(this.object.data?.contentType?.toLowerCase()== 'line'){
        this.map.addLayer({
          id: poi.identifier,
          type: 'line',
          source: poi.identifier,
          paint: {
            'line-color': '#FFB300',
            'line-width': 4
          }
        });
        this.map.moveLayer(poi.identifier);
      }
    }
  }

  private flyToBoundsGeoObject(poi: PointOfInterest, features:any[]) {
    if (features.length > 0) {
      const featureCollection = turf.featureCollection(features)
      const boundingBox = turf.bbox(featureCollection)
      const mapbbox = new mapboxgl.LngLatBounds([boundingBox[0], boundingBox[1]], [boundingBox[2], boundingBox[3]])
      // mapbbox.extend() maybe for fitting multiple bboxes...
      this.map.fitBounds(mapbbox, {padding: 15})     
    }
  }

}
